import { AppShell, Loader } from "@mantine/core";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { createContext, useState } from "react";
import { useAuth } from "../../hooks/core/useAuth";
import { Sidebar } from "./Components/Sidebar";
import Header from "./Components/Header";
import LocationTracker from "../../shared/components/LocationTracker";

export const SidebarContext = createContext();

export function MainLayout() {
  const { user, staffProfile, isLoading } = useAuth();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1.2em",
        }}
      >
        <Loader color="blue" size="xl" type="bars" />
      </div>
    );
  }

  // Only redirect if definitely not authenticated
  if (!user || !staffProfile) {
    return <Navigate to="/auth" state={{ from: location }} replace={false} />;
  }

  return (
    <SidebarContext.Provider value={{ sidebarCollapsed, setSidebarCollapsed }}>
      <AppShell
        padding="md"
        navbar={{ width: sidebarCollapsed ? 60 : 250, breakpoint: "sm" }}
        header={{ height: 60 }}
        layout="alt"
      >
        {/* Track location changes */}
        <LocationTracker />

        <AppShell.Header>
          <Header />
        </AppShell.Header>

        <AppShell.Navbar>
          <Sidebar />
        </AppShell.Navbar>

        <AppShell.Main>
          <Outlet />
        </AppShell.Main>
      </AppShell>
    </SidebarContext.Provider>
  );
}

export default MainLayout;
